import React from "react";
const ServicesAreaSection = () => <section>hey i'm ServicesAreaSection</section>;
export default ServicesAreaSection;
